export class AutorisationBnbaccess {
    constructor(
        public id?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/autorisation/autorisation-bnbaccess.model.ts